import React, { useContext } from 'react';
import {
  UserOutlined,
  EditOutlined,
  SyncOutlined,
  StopOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { UserDisplay } from '../types/UserDisplay';
import { ModalType } from '../controllers/useUsersPageController';
import { Flex, MenuProps, Typography } from 'antd';
import { ECreditType, UserRole } from '@leedpulse-monorepo/enums';
import AuthenticationContext from '../../../contexts/auth/AuthenticationContext';

export const getActionMenuItems = (
  user: UserDisplay,
  openModal: (type: ModalType, user: UserDisplay) => void,
  isDegradedMode: boolean,
  isCompanyExternallyBilled = false
) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks 
  const authentication = useContext(AuthenticationContext); // this func is always called in a react component so we can usecontext here

  const status = user.status;

  const viewProfile = {
    key: 'view',
    label: 'Voir le profil',
    icon: <UserOutlined />,
    onClick: () => openModal('VIEW_PROFILE', user),
  };
  const edit = {
    key: 'edit',
    label: 'Editer',
    icon: <EditOutlined />,
    onClick: () => openModal('EDIT_USER', user),
  };
  const hasNumber = user.sender && user.sender.length > 0;
  const changeNumber = {
    key: 'change-number',
    label: hasNumber ? 'Changer de numéro' : 'Assigner un numéro',
    icon: <SyncOutlined />,
    onClick: () => openModal('CHANGE_NUMBER', user),
    disabled: isDegradedMode && !isCompanyExternallyBilled,
  };
  const deactivate = {
    key: 'deactivate',
    label: 'Désactiver',
    icon: <StopOutlined />,
    onClick: () => openModal('DEACTIVATE_USER', user),
  };
  const reactivate = {
    key: 'reactivate',
    label: 'Réactiver',
    icon: <UserOutlined />,
    onClick: () => openModal('REACTIVATE_USER', user),
    disabled: true,
  };
  const removeFromCompany = {
    key: 'remove',
    label: `Retirer de l'entreprise`,
    icon: <DeleteOutlined />,
    danger: true,
    onClick: () => openModal('DELETE_USER', user),
  };

  const items: MenuProps['items'] = [];
  switch (status) {
    case 'Invité':
      items.push(viewProfile, edit, changeNumber, removeFromCompany);
      break;
    case 'Inactif':
      // Inactif = no number assigned yet — keep assign / edit / delete options
      items.push(viewProfile, edit, changeNumber, removeFromCompany);
      break;
    case 'Actif':
      items.push(viewProfile, edit, changeNumber, deactivate, removeFromCompany);
      break;
    default:
      items.push(viewProfile, edit, removeFromCompany);
      break;
  }

  if ([UserRole.owner].includes(authentication.authentication?.role ?? UserRole.customer)) {
    items.push({
      key: 'dev-infos',
      type: 'divider',
    });
    items.push({
      key: 'dev-infos',
      type: 'group',
      label: <Flex vertical>
        <Typography.Text style={{ color: 'var(--text-secondary-color)' }}>id: {user.id}</Typography.Text>
        <Typography.Text style={{ color: 'var(--text-secondary-color)' }}>status: {user.status}</Typography.Text>
        <Typography.Text style={{ color: 'var(--text-secondary-color)' }}>sub: {user.idSubscription}</Typography.Text>
        <Typography.Text style={{ color: 'var(--text-secondary-color)' }}>leedbucks: {user.credits_info?.remaining?.[ECreditType.leedbucks] ?? 0} / {user.credits_info?.total?.[ECreditType.leedbucks] || 0}</Typography.Text>
      </Flex>,
    });
  }

  return items;
};
